export { updateShippingOption } from './updateShippingOption'

// Tweaks the address to force BigCommerce to return a valid shipping quote
export { recoverAvailableShippingOptions } from './recoverAvailableShippingOptions'

export { default as recoverShippingOptions } from './recoverShippingOptions'

export {
  updateShippingAddress,
  isOrderUpdatePending,
} from './updateShippingAddress'

export { createNonBopusConsignments } from './createNonBopusConsignments'
